import {RouteDefinition} from '../../../routes';
import {UartScreen} from './UartScreen';

export const UartSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/developer/uart',
        component: UartScreen,
        exact: true,
    },
];
